import React from 'react';
import NumberFormat from 'react-number-format';
import { Input } from 'synapsefi-dev-ui';

const CustomNumberInput = props => {
  const { type, onChange, format, symbol, placeholder, propName, ...inputProps } = props;

  return (
    <NumberFormat
      isAllowed={(values) => {
        const {floatValue} = values;
        return floatValue >= 0;
      }}
      format={format}
      {...inputProps}
      customInput={Input}
      placeholder={placeholder}
      onValueChange={(values, e) => onChange(e, values.value, propName)}
      propName={propName}
    />
  );
};
export default CustomNumberInput;
